export enum Direction {
  LTR = "LTR",
  RTL = "RTL",
}
